var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    { on: { submit: _vm.submit } },
    [
      _c(
        "v-banner",
        { staticClass: "opportunity-user-input", attrs: { sticky: "" } },
        [
          _c("detail-data-single-label", {
            attrs: {
              "detail-label": _vm.$t(
                "view.sales_force.reflect.label.contract.apply_date"
              ),
              "detail-value": [_vm.parseDate(_vm.form["applyInfoApplyDate"])]
            }
          }),
          _vm._v(" "),
          _c("detail-data-single-label", {
            attrs: {
              "detail-label": _vm.$t(
                "view.sales_force.reflect.label.contract.apply_shipping_address"
              ),
              "detail-value": [
                "〒 " +
                  _vm.form["shippingAddressInfoZip1"] +
                  "-" +
                  _vm.form["shippingAddressInfoZip2"],
                _vm.form["shippingAddressInfoAddress1"] +
                  " " +
                  _vm.form["shippingAddressInfoAddress2"] +
                  " " +
                  _vm.form["shippingAddressInfoAddress3"]
              ]
            }
          }),
          _vm._v(" "),
          _c("detail-data-single-label", {
            attrs: {
              "detail-label": _vm.$t(
                "view.sales_force.reflect.label.contract.apply_seihin"
              ),
              "detail-value": [
                _vm.$t(
                  "view.sales_force.reflect.label.contract.additional_tablet"
                )
              ]
            }
          }),
          _vm._v(" "),
          _c("detail-data-single-label", {
            attrs: {
              "detail-label": _vm.$t(
                "view.sales_force.reflect.label.contract.apply_period"
              ),
              "detail-value": [
                _vm.$t(
                  "view.sales_force.reflect.label.fixed_text.additional_tablet_plan_name"
                )
              ]
            }
          }),
          _vm._v(" "),
          _c("detail-data-single-label", {
            attrs: {
              "detail-label": _vm.$t(
                "view.contract_form.update.label.apply_info.start_date"
              ),
              "detail-value": [
                _vm.parseDate(_vm.form["applyInfoAdditionalTabletStartDate"])
              ]
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider", { staticClass: "mt-2" }),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("商談／商談商品")) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "12", md: "12" }
            },
            [
              _c("v-data-table", {
                attrs: {
                  hover: true,
                  "hide-default-footer": "",
                  headers: _vm.tableHeadersOpportunity,
                  items: _vm.salesForceInfo.additionalTabletRegisterObj,
                  "no-data-text":
                    "SALESFORCE連携後、商談／商談商品が表示されます。"
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.opportunityName",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c(
                          "a",
                          {
                            attrs: {
                              href:
                                "" +
                                _vm.makeSalesForceUrl() +
                                item.opportunityId +
                                "/view",
                              target: "_blank",
                              rel: "noopener noreferrer"
                            }
                          },
                          [
                            _vm._v(
                              " \n                " +
                                _vm._s(item.opportunityName)
                            )
                          ]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.price_book.price_book_select"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "10", sm: "10", md: "5" }
            },
            [
              _c("v-text-field", {
                staticClass: "mt-0 pt-0 pb-0",
                attrs: {
                  "persistent-hint": "",
                  disabled: "",
                  hint: _vm.$t(
                    "※タブレット単体申込みの場合、価格表は【Rehab Cloud】で固定です。"
                  )
                },
                model: {
                  value: _vm.fixedTextPriceList,
                  callback: function($$v) {
                    _vm.fixedTextPriceList = $$v
                  },
                  expression: "fixedTextPriceList"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.opportunity.product"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "10", sm: "10", md: "5" }
            },
            [
              _c("v-text-field", {
                staticClass: "mt-0 pt-0 pb-0",
                attrs: {
                  "persistent-hint": "",
                  disabled: "",
                  hint: _vm.$t(
                    "※タブレット単体申込みの場合、商品は【Rehab Cloud タブレット】【Rehab Cloud タブレット初回手数料】で固定です。"
                  )
                },
                model: {
                  value: _vm.fixedTextItem,
                  callback: function($$v) {
                    _vm.fixedTextItem = $$v
                  },
                  expression: "fixedTextItem"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.contract.tablet"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "12", md: "2" }
            },
            [
              _c("v-text-field", {
                staticClass: "mt-0 pt-0 pb-0",
                attrs: {
                  "persistent-hint": "",
                  disabled: "",
                  hint: _vm.$t("申し込んで頂くタブレットの台数（変更不可）"),
                  autocomplete: "off",
                  type: "number",
                  suffix: _vm.$t(
                    "view.sales_force.reflect.label.contract.tablets"
                  )
                },
                model: {
                  value: _vm.salesForceInfo.additionalTablets,
                  callback: function($$v) {
                    _vm.$set(_vm.salesForceInfo, "additionalTablets", $$v)
                  },
                  expression: "salesForceInfo.additionalTablets"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("申込みタブレット販売価格合計")) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "12", md: "5" }
            },
            [
              _c("v-data-table", {
                attrs: {
                  hover: true,
                  "hide-default-footer": "",
                  "disable-sort": "",
                  headers: _vm.tabletHeaders,
                  items: _vm.tabletItems
                },
                scopedSlots: _vm._u([
                  {
                    key: "item",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c("tr", [
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.salesForceInfo.displayDataTableObj[
                                  "rehabCloudTabletInitialFeeText"
                                ]
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                "¥" +
                                  _vm.salesForceInfo.displayDataTableObj[
                                    "rehabCloudTabletInitialFeeMonthly"
                                  ].toLocaleString()
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(_vm.salesForceInfo.additionalTablets))
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                "¥" +
                                  _vm.salesForceInfo.displayDataTableObj[
                                    "initialFeeTotalPrice"
                                  ].toLocaleString() +
                                  "（初月のみ）"
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.salesForceInfo.displayDataTableObj[
                                  "rehabCloudTabletText"
                                ]
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                "¥" +
                                  _vm.salesForceInfo.displayDataTableObj[
                                    "rehabCloudTabletMonthly"
                                  ].toLocaleString()
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(_vm.salesForceInfo.additionalTablets))
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                "¥" +
                                  _vm.salesForceInfo.displayDataTableObj[
                                    "tabletsTotalPrice"
                                  ].toLocaleString()
                              )
                            )
                          ])
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.contract.apply_start_date"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "12", md: "5" }
            },
            [
              _c("date-picker-wrapper", {
                attrs: {
                  classes: "mt-0 pt-0 pb-0",
                  disabled: true,
                  hint: _vm.$t(
                    "view.sales_force.reflect.hint.contract.apply_start_date"
                  ),
                  type: "date"
                },
                model: {
                  value: _vm.salesForceInfo.additionalTabletContractStartDate,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.salesForceInfo,
                      "additionalTabletContractStartDate",
                      $$v
                    )
                  },
                  expression: "salesForceInfo.additionalTabletContractStartDate"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.contract.request_start_date"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "12", md: "5" }
            },
            [
              _c("date-picker-wrapper", {
                attrs: {
                  classes: "mt-0 pt-0 pb-0",
                  hint: _vm.$t(
                    "view.sales_force.reflect.hint.contract.request_start_date"
                  ),
                  type: "date"
                },
                model: {
                  value: _vm.salesForceInfo.additionalTabletRequestStartDate,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.salesForceInfo,
                      "additionalTabletRequestStartDate",
                      $$v
                    )
                  },
                  expression: "salesForceInfo.additionalTabletRequestStartDate"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 align-center fixed-label-area",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold ml-4 fixed-label" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.contract.contract_edate"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "12", md: "5" }
            },
            [
              _c("date-picker-wrapper", {
                attrs: {
                  classes: "mt-0 pt-0 pb-0",
                  hint: _vm.$t(
                    "view.sales_force.reflect.hint.contract.contract_edate"
                  ),
                  type: "date"
                },
                model: {
                  value: _vm.salesForceInfo.additionalTabletContractEdate,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.salesForceInfo,
                      "additionalTabletContractEdate",
                      $$v
                    )
                  },
                  expression: "salesForceInfo.additionalTabletContractEdate"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        { staticClass: "mt-3" },
        [
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-0 pb-0 pr-0",
              attrs: { cols: "12", sm: "12", md: "4" }
            },
            [
              _c(
                "v-sheet",
                {
                  staticClass: "pt-3 pb-3 fixed-label-area align-center",
                  attrs: { color: "grey lighten-3" }
                },
                [
                  _c(
                    "label",
                    { staticClass: "mb-0 font-weight-bold fixed-label ml-4" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "view.sales_force.reflect.label.contract.tokubetu_detail"
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass: "mb-0 mt-0 pt-2 pb-0",
              attrs: { cols: "12", sm: "12", md: "8" }
            },
            [
              _c("v-textarea", {
                staticClass: "mt-0",
                attrs: {
                  outlined: "",
                  rows: "2",
                  "persistent-hint": "",
                  hint: _vm.$t(
                    "view.sales_force.reflect.hint.contract.tokubetu_detail"
                  )
                },
                model: {
                  value: _vm.salesForceInfo.additionalTabletTokubetuDetail,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.salesForceInfo,
                      "additionalTabletTokubetuDetail",
                      $$v
                    )
                  },
                  expression: "salesForceInfo.additionalTabletTokubetuDetail"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("sales-force-button-area", {
        attrs: { "disable-csv-output": true },
        on: { reflect: _vm.submit, "re-correct": _vm.reCorrect }
      }),
      _vm._v(" "),
      _c("simple-dialog", {
        attrs: {
          "show-dialog": _vm.showConfirmDialog,
          "max-width": "800",
          "default-msg": _vm.confirmMessage
        },
        on: {
          "ok-click": function($event) {
            return _vm.reflect()
          },
          "cancel-click": function($event) {
            return _vm.dialogClose()
          }
        }
      }),
      _vm._v(" "),
      _c("simple-dialog", {
        attrs: {
          "show-dialog": _vm.showAlertDialog,
          "max-width": "800",
          "is-confirm": false,
          "default-msg": _vm.alertMessage
        },
        on: {
          "ok-click": function($event) {
            return _vm.dialogClose()
          },
          "cancel-click": function($event) {
            return _vm.dialogClose()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62a59849", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62a59849","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sales_force/OpportunityAdditionalTablet.vue
// module id = Cimu
// module chunks = 1